import logo from "../../assets/images/logoFederfarma.png"
import ButtonSubmit from "../common/buttonSubmit";


const HeaderModal = (props: any) => {

  let title = props.title ?? '';

  let textButtonRight = props.textButtonRight ?? ""

  return (
    <div className="Header">
      <div className="row m-0">
        <div className="col-lg-2 text-lg-left text-center p-30">
          <img alt="Logo" src={logo} className="logoHeader" />
        </div>
        <div className="col-lg-8 mt-2 text-center p-30">
          <h4>{title}</h4>
        </div>
        {textButtonRight &&
          <div className="col-lg-2 text-lg-right text-center p-30">
            <ButtonSubmit handleChange={props.handleClick} textButton={textButtonRight} />
          </div>
        }
      </div>
    </div>
  )
}

export default HeaderModal;
